import * as types from './mutation-types'

export default {
  [types.SET_AVAILABLE_SUBSCRIPTIONS_LIST] (state, availableSubscriptionsList) {
    state.availableSubscriptionsList = availableSubscriptionsList
  }
}
